import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { Box, Chip, Grid, Typography } from "@mui/material";
import useColors from "../../../../api/hooks/useColors";
import CustomToolTip from "../../../../components/CustomTooltip";

const RowInBreezeScore = ({ rowScore, name, weight, tooltipText = "" }) => {
  const colors = useColors();

  const colorLabelMap = {
    success: {
      color: colors.success_main,
      backgroundColor: colors.success_16percent,
    },
    warning: {
      color: colors.warning_dark,
      backgroundColor: colors.warning_16percent,
    },
    error: {
      color: colors.error_main,
      backgroundColor: colors.error_16percent,
    },
    warning_yellow: {
      color: colors.mitre_yellow_label_text,
      backgroundColor: colors.warning_8percent,
    },
  };

  const mapBreezeScoreInfoToColor = (score) => {
    if (score <= 2.5) {
      return colorLabelMap.success;
    } else if (score <= 5) {
      return colorLabelMap.warning_yellow;
    } else if (score <= 7.5) {
      return colorLabelMap.warning;
    } else {
      return colorLabelMap.error;
    }
  };

  let rowScoreFloat = parseFloat(rowScore);
  if (name === "Scenarios Risk" || name === "Compensating Controls") {
    // Convert score to 0-100%
    rowScoreFloat = rowScoreFloat * 10;
  }
  const formattedRowScore =
    rowScoreFloat % 1 === 0
      ? rowScoreFloat.toFixed(0)
      : rowScoreFloat.toFixed(1);
  const formattedLabel =
    name === "Scenarios Risk" || name === "Compensating Controls"
      ? formattedRowScore + "%"
      : formattedRowScore;
  return (
    <Grid
      container
      display={"flex"}
      flexDirection={"row"}
      justifyContent={"space-between"}
      alignItems={"center"}
      width={"100%"}
    >
      <Grid item xs={2}>
        <Chip
          label={formattedLabel}
          size={"small"}
          sx={{
            ...mapBreezeScoreInfoToColor(rowScore),
            fontWeight: "regular",
            fontSize: "12px",
            width: "50px",
            height: "18px",
            borderRadius: "6px",
          }}
        />
      </Grid>
      <Grid item xs={4.5}>
        <Box display={"flex"} alignItems={"center"} gap={0.5}>
          <Typography variant="overline">{name} </Typography>
          <CustomToolTip title={tooltipText}>
            <HelpOutlineIcon
              sx={{
                color: colors.text_secondary,
                width: "12px",
                height: "12px",
              }}
            />
          </CustomToolTip>
        </Box>
      </Grid>

      <Grid
        item
        xs={3}
        display={"flex"}
        flexDirection={"row"}
        gap={1}
        alignItems={"center"}
        sx={{ paddingLeft: 4 }}
      >
        <Typography variant="caption">X</Typography>
        <Typography variant="caption">{weight * 100}%</Typography>
      </Grid>
      <Grid item xs={2}>
        <Box
          width={"100%"}
          display={"flex"}
          flexDirection={"row"}
          justifyContent={"flex-end"}
        >
          <Chip
            label={parseFloat((rowScore * weight).toFixed(2))}
            size={"small"}
            sx={{
              background: colors.primary_8percent,
              color: colors.primary_main,
              fontWeight: "regular",
              fontSize: "12px",
              width: "50px",
              height: "18px",
              borderRadius: "6px",
            }}
          />
        </Box>
      </Grid>
    </Grid>
  );
};

export default RowInBreezeScore;
